import { ToastCustom } from "@components";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { toast } from "sonner";
import { updateExpense } from "../services";
import type { UpdateExpensePayloadApi } from "../types";

export function useUpdateExpense(onSuccessCallback?: () => void) {
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: ({
			expenseId,
			payload,
		}: {
			expenseId: string | number;
			payload: UpdateExpensePayloadApi;
		}) => updateExpense(expenseId, payload),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["expenses"] });

			onSuccessCallback?.();

			toast(
				ToastCustom({
					description: "Sua despesa já está pronta para ser consultada.",
					title: "Despesa atualizada com sucesso!",
					variant: "success",
				})
			);

			mutation.reset();
		},
		onError: (error) => {
			if (error instanceof AxiosError) {
				const errorData = error.response?.data;
				if (errorData?.error?.errors?.length > 0 || errorData?.error?.detail) {
					const errorMessages =
						errorData?.error?.errors[0] || errorData?.error?.detail;
					toast(ToastCustom({ description: errorMessages, title: "Erro" }));
					return;
				}
			}

			const message =
				(error as { response?: { data?: { message?: string } } })?.response
					?.data?.message ?? "Erro ao atualizar despesa";
			toast(
				ToastCustom({
					description: message,
					title: "Erro",
					variant: "error",
				})
			);
		},
	});

	return mutation;
}
